<template>
    <div>
        <div class="overlay" v-if="visible">
            <div class="header">
                <slot name="header">
                    <div class="row">
                        <div class="col">
                            <div @click="close" id="close">
                                <i class="fas fa-times fa-2x" style="height: 100%"></i>
                            </div>
                        </div>
                    </div>
                </slot>
            </div>
                

            <!-- Divider -->
            <div class="row">
                <div class="col no-gutters" style="padding: 0;">
                    <hr class="solid" style="margin: 0">
                </div>
            </div>  
            
            <div class="body" v-body-scroll-lock="visible">
                <slot name="content"></slot>
            </div>

            <!-- Divider -->
            <div class="row">
                <div class="col no-gutters" style="padding: 0;">
                    <hr class="solid" style="margin: 0;">
                </div>
            </div>  

            <div class="footer">
                <slot name="footer">
                    <button class="btn btn-primary btn-block" @click="visible = false">{{ $t('components.modalOverlay.showResults') }}</button>
                </slot>
            </div>
        </div>

        <slot name="activator" :on="on">
            <button class="btn btn-primary btn-block" v-on="on">
                {{ $t('components.modalOverlay.openOverlay') }}
            </button>
        </slot>
    </div>
</template>


<script>
export default {
    name: 'ModalOverlay',
    props: {
        value: {
            type: Boolean,
            required: true,
            default: true
        }
    },
    computed: {
        visible: {
            get() {
                return this.value;
            }, set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        open: function(event) {
            this.visible = true;
        },
        close: function() {
            this.visible = false;
        }
    },
    data() {
        return {
            on: {
                click: this.open
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10000;
    background-color: white;

    // Flex
    display: flex;
    flex-direction: column;


    .header {
        justify-content: center;
        display: flex;

        padding: 16px;
        min-height: 56px;
    }

    .body {
        // position: relative;
        overflow-y: scroll;
        overflow-x: hidden;
        word-wrap: break-word;
        flex-basis: auto;
        flex-grow: 1;
        flex-shrink: 1;
        padding-top: 12px;
        padding-bottom: 12px;
    }

    .footer {
        display: flex;
        padding: 8px;
        min-height: 64px;
    }
}

#close {
    cursor: pointer;
}

.close {
    position: relative;
    top: 0;
    left: 0;
}
</style>